export default {
  uploadingLogo: 'Enviando logo',
  cancel: 'Cancelar',
  modelSettings: 'Configurações do modelo:',
  save: 'Salvar',
  displayTab: 'Aparência',
  customNamesTab: 'Nomes Personalizados',
  metadataTab: 'Metadados',
  channelTaxonomyTab: 'Taxonomia de Canais',
  channelTaxonomyChannels: 'Canais',
  channelTaxonomyNoChannels: 'Este modelo não tem canais de mídia.',
  taxonomyLevelL0: 'Peso',
  taxonomyLevelL1: 'Estratégia',
  taxonomyLevelL2: 'Definição',
  taxonomyLevelL3: 'Abertura',
  taxonomyLevelL4: 'Formato',
  taxonomyLevelL5: 'Fornecedor',
  taxonomyLevelL6: 'Personalizado',
  taxonomySelectParentFirst: 'Selecione {parent} primeiro',
  metadataClient: 'Cliente',
  metadataBrand: 'Marca',
  metadataCategory: 'Categoria',
  metadataSubCategory: 'Subcategoria',
  metadataCountry: 'País',
  addValueTitle: 'Adicionar novo valor',
  addValueButton: 'Adicionar',
  addValueTooltip: 'Adicionar um novo valor',
  addValueAbbreviationLabel: 'Abreviação',
  addValueAbbreviationNoSpaces: 'A abreviação não pode conter espaços',
  prettyMediaNames: 'Nomes de Mídia',
  originalName: 'Nome Original',
  displayName: 'Nome de Exibição',
  prettyComponentNames: 'Nomes de Componentes',
  addPrettyComponentName: 'Adicionar Nome de Componente',
  delete: 'Excluir',
  prettyExternalVariableNames: 'Nomes de Variáveis Externas',
  addExternalVariableName: 'Adicionar Nome de Variável Externa',
  primaryColor: 'Cor Primária',
  primaryColorLabel: 'Cor Primária (ex. #FF0000)',
  customKpiName: 'Nome de KPI (substitui "Vendas")',
  customKpiNameLabel: 'Nome de KPI Personalizado',
  logo: 'Logo',
  hiddenKpis: 'KPIs ocultos',
  hiddenKpisLabel: 'KPIs a ocultar',
  hiddenKpisHint: 'Os KPIs ocultos não são exibidos a nenhum usuário no Model Report, nos planos, no What-If nem no Compare Plans. Enquanto houver algum KPI oculto, o Total também fica oculto.',
  hiddenKpisAtLeastOne: 'Pelo menos um KPI deve permanecer visível',
  chooseLogoFile: 'Escolher novo arquivo de logo (PNG/JPG)',
  deleteLogo: 'Excluir logo',
  required: 'Obrigatório',
  duplicatedMediaName: 'Nome de mídia duplicado',
  invalidPrimaryColor: 'Cor Primária inválida',
  errorUploadingLogo: 'Erro ao enviar o logo',
  componentNamesEmptyError: 'Os nomes personalizados de componentes não podem ter valores vazios',
  componentNamesDuplicateError: 'Os nomes personalizados de componentes não podem ter nomes originais duplicados',
  externalVariablesEmptyError: 'Os nomes personalizados de variáveis externas não podem ter valores vazios',
  externalVariablesDuplicateError: 'Os nomes personalizados de variáveis externas não podem ter nomes originais duplicados',
  errorUpdatingSettings: 'Erro ao atualizar as configurações'
}
